import "core-js/modules/es.array.reduce";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import { useContext } from 'react';
import invariant from 'invariant';
import MuiComponentsContext from '../MuiComponentsProvider/MuiComponentsContext';
export default function useMuiComponentsContext(settingNames) {
  var ctx = useContext(MuiComponentsContext);
  invariant(ctx, "Don't use 'useMuiComponentsContext' outside of <MuiComponentsProvider>");
  if (typeof settingNames === 'string') return ctx[settingNames];
  if (Array.isArray(settingNames)) return settingNames.reduce(function (a, i) {
    return _extends({}, a, _defineProperty({}, i, ctx[i]));
  }, {});
  return ctx;
}